<template>
    <div class="sidebar-menu-container">
        <div class="sidebar-main-label">Наличники</div>
<!--        <div class="three-positions-switch">-->
<!--            <div class="three-positions-switch-button rounded-left-button" v-bind:class="{'active-button': activePlatbandToolMode === 'scaling'}" v-on:click="changePlatbnandMode('scaling')">-->
<!--                Масштаб-->
<!--            </div>-->
<!--            <div class="three-positions-switch-button center-button" v-bind:class="{'active-button': activePlatbandToolMode === 'moving'}" v-on:click="changePlatbnandMode('moving')">-->
<!--                Геометрия-->
<!--            </div>-->
<!--            <div class="three-positions-switch-button rounded-right-button" v-bind:class="{'active-button': activePlatbandToolMode === 'centering'}" v-on:click="changePlatbnandMode('centering')">-->
<!--                Позиция-->
<!--            </div>-->
<!--        </div>-->
        <div class="sidebar-text-area">
            Выберите режим редактированя:
        </div>
        <select class="cd-modal-text-input" v-model="activePlatbandToolMode" v-on:change="changePlatbnandMode()">
            <option value="scaling">Масштабирование</option>
            <option value="moving">Изменение геометрии</option>
            <option value="centering">Перемещение</option>
        </select>

        <div v-show="activePlatbandToolMode === 'scaling'">
            <div class="sidebar-text-area">В режиме <span class="red-text bold-text">"масштабирование"</span> можно изменять рамер наличника с сохранением исходных пропорций. Для масштабирования
                <span class="red-text bold-text">переместитие</span> любую <span class="red-text bold-text">точку</span> плоскости, как показано на рисунке.
            </div>

            <div class="sidebar-step-two-img-container">
                <img class="sidebar-step-two-img" :src="urlForStatic('/img/platband_tip.png')"/>
            </div>
        </div>

        <div v-show="activePlatbandToolMode === 'moving'">
            <div class="sidebar-text-area">В режиме <span class="red-text bold-text">"изменение геометрии"</span> можно произвольно перемещать угловые точки наличника, изменяя его форму. Для этого
                <span class="red-text bold-text">переместитие</span> любую <span class="red-text bold-text">точку</span> плоскости, как показано на рисунке.
            </div>

            <div class="sidebar-step-two-img-container">
                <img class="sidebar-step-two-img" :src="urlForStatic('/img/platband_tip_2.png')"/>
            </div>
        </div>

        <div v-show="activePlatbandToolMode === 'centering'">
            <div class="sidebar-text-area">В режиме <span class="red-text bold-text">"перемещение"</span> можно равномерно сдвигать плоскость наличника. Для этого
                <span class="red-text bold-text">переместитие</span> любую <span class="red-text bold-text">точку</span> плоскости, как показано на рисунке.
            </div>

            <div class="sidebar-step-two-img-container">
                <img class="sidebar-step-two-img" :src="urlForStatic('/img/platband_tip_3.png')"/>
            </div>
        </div>


    </div>
</template>

<script>
    import {urlForStaticVue} from "../../common";
    import {bus} from "../../../vue_bus";

    export default {
        name: "PlatbandSidebarMenu",
        mixins: [urlForStaticVue],
        data() {
            return {
                activePlatbandToolMode: 'scaling'
            }
        },
        methods: {
            changePlatbnandMode() {
                bus.$emit("changePlatbandToolMode", (this.activePlatbandToolMode));
                console.log(this.activePlatbandToolMode)
            }
        }
    }
</script>

<style scoped>
    .extra-margin {
        margin: 20px 0;
    }

    @media screen and (max-height: 800px) {
        .three-positions-switch-button {
            font-size: 12px;
        }
    }

    @media screen and (min-height: 800px) {
        .three-positions-switch-button {
            font-size: 14px;
        }
    }

    .three-positions-switch {
        display: inline-flex;
        /*grid-template-columns: max-content max-content max-content;*/
        margin: 20px 0;
    }

    .three-positions-switch-button {
        padding: 10px;
        border: 2px solid #939393;
        cursor: pointer;
        font-weight: bold;
        color: #939393;
        user-select: none;
    }

    .three-positions-switch-button:hover {
        color: #838383;
    }

    .rounded-left-button {
        border-bottom-left-radius: 50px;
        border-top-left-radius: 50px;
        border-right: 1px solid;
    }

    .center-button {
        border-left: 1px solid;
        border-right: 1px solid;
    }

    .rounded-right-button {
        border-bottom-right-radius: 50px;
        border-top-right-radius: 50px;
        border-left: 1px solid;
    }

    .active-button {
        color: white;
        background-color: #d83336;
        border-color: #d83336
    }

    .active-button:hover {
        color: white !important;

    }

</style>
